function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { logger } from '@sentry/utils';
import { DEBUG_BUILD } from '../debug-build.js';
import { getClient, getCurrentScope } from '../exports.js';
import { spanToJSON } from '../utils/spanUtils.js';
import { COUNTER_METRIC_TYPE, DISTRIBUTION_METRIC_TYPE, SET_METRIC_TYPE, GAUGE_METRIC_TYPE } from './constants.js';
import { MetricsAggregator, metricsAggregatorIntegration } from './integration.js';

function addToMetricsAggregator(metricType, name, value) {
  var data = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var client = getClient();
  var scope = getCurrentScope();

  if (client) {
    if (!client.metricsAggregator) {
      DEBUG_BUILD && logger.warn('No metrics aggregator enabled. Please add the MetricsAggregator integration to use metrics APIs');
      return;
    }

    var unit = data.unit,
        tags = data.tags,
        timestamp = data.timestamp;

    var _client$getOptions = client.getOptions(),
        release = _client$getOptions.release,
        environment = _client$getOptions.environment; // eslint-disable-next-line deprecation/deprecation


    var transaction = scope.getTransaction();
    var metricTags = {};

    if (release) {
      metricTags.release = release;
    }

    if (environment) {
      metricTags.environment = environment;
    }

    if (transaction) {
      metricTags.transaction = spanToJSON(transaction).description || '';
    }

    DEBUG_BUILD && logger.log("Adding value of ".concat(value, " to ").concat(metricType, " metric ").concat(name));
    client.metricsAggregator.add(metricType, name, value, unit, _objectSpread(_objectSpread({}, metricTags), tags), timestamp);
  }
}
/**
 * Adds a value to a counter metric
 *
 * @experimental This API is experimental and might have breaking changes in the future.
 */


function increment(name) {
  var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var data = arguments.length > 2 ? arguments[2] : undefined;
  addToMetricsAggregator(COUNTER_METRIC_TYPE, name, value, data);
}
/**
 * Adds a value to a distribution metric
 *
 * @experimental This API is experimental and might have breaking changes in the future.
 */


function distribution(name, value, data) {
  addToMetricsAggregator(DISTRIBUTION_METRIC_TYPE, name, value, data);
}
/**
 * Adds a value to a set metric. Value must be a string or integer.
 *
 * @experimental This API is experimental and might have breaking changes in the future.
 */


function set(name, value, data) {
  addToMetricsAggregator(SET_METRIC_TYPE, name, value, data);
}
/**
 * Adds a value to a gauge metric
 *
 * @experimental This API is experimental and might have breaking changes in the future.
 */


function gauge(name, value, data) {
  addToMetricsAggregator(GAUGE_METRIC_TYPE, name, value, data);
}

var metrics = {
  increment: increment,
  distribution: distribution,
  set: set,
  gauge: gauge,

  /** @deprecated Use `metrics.metricsAggregratorIntegration()` instead. */
  // eslint-disable-next-line deprecation/deprecation
  MetricsAggregator: MetricsAggregator,
  metricsAggregatorIntegration: metricsAggregatorIntegration
};
export { distribution, gauge, increment, metrics, set };